export const IMAGES = {
  noImage: require('./no-image.png'),
  loginPageLogo: require('./LOGIN_PAGE_LOGO.png'),
  mainLogo: require('./COMPANY_LOGO.png')
}
